module.exports = __webpack_public_path__ + "static/media/App_Store_Badge.ad27b317.png";